import { useState } from "react";

export const carouselArr = [
  "images/1-min.jpg",
  "images/2-min.jpg",
  "images/3-min.jpg",
  "images/4-min.jpg",
  "images/5-min.jpg",
  "images/6-min.jpg",
  "images/7-min.jpg",
  "images/8-min.jpg",
];

export const fieldsArr = [
  { name: "Javascript", image: "images/javascript.png" },
  { name: "Python", image: "images/python.png" },
  { name: "Php", image: "images/php.png" },
  { name: "Sql", image: "images/sql.png" },
  { name: "MongoDb", image: "images/mongodb.png" },
  { name: "React", image: "images/react.png" },
  { name: "NodeJs", image: "images/nodejs.png" },
];
